/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetLedgerBalancesByUserIDOptions,
  GetLedgerBalancesByUserIDResponses,
} from '../types/GetLedgerBalancesByUserID'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get a specific user's available, locked, and borrowed assets
 * {@link /v1/ledger/balances/:user_id}
 */
export function getLedgerBalancesByUserID<ThrowOnError extends boolean = true>(
  options: Options<GetLedgerBalancesByUserIDOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetLedgerBalancesByUserIDResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/ledger/balances/{user_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetLedgerBalancesByUserIDResponses, ThrowOnError>>,
  )
}
